<template>
  <div>
    <v-card elevation="2" outlined shaped tile class="mb-2">
      <v-card-title>Resumen Ruta</v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-form ref="form_filter" v-model="valid_filter" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-menu
                    ref="startDate_menu"
                    v-model="select_startDate_menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="mainFilters.startDate"
                        :label="$t('brands.start_date')"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="requiredRules"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="mainFilters.startDate"
                      no-title
                      @input="select_startDate_menu = false"
                      :first-day-of-week="1"
                      :locale="this.$i18n.locale"
                      @change="onChangeDates"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-menu
                    ref="endDate_menu"
                    v-model="select_endDate_menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="mainFilters.endDate"
                        :label="$t('brands.end_date')"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="requiredRules"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="mainFilters.endDate"
                      no-title
                      scrollable
                      @input="select_endDate_menu = false"
                      :first-day-of-week="1"
                      :locale="this.$i18n.locale"
                      @change="onChangeDates"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-autocomplete
                    v-model="mainFilters.responsibleId"
                    :label="$t('responsible')"
                    :placeholder="$t('start_typing_to_search')"
                    item-text="label"
                    item-value="value"
                    :search-input.sync="search_responsible"
                    :loading="isSearching['responsible']"
                    :items="filtered_responsible"
                    hide-no-data
                    filled
                    multiple
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-autocomplete
                    v-model="mainFilters.gpvId"
                    :label="$t('gpv')"
                    :placeholder="$t('start_typing_to_search')"
                    item-text="label"
                    item-value="value"
                    :search-input.sync="search_gpv"
                    :loading="isSearching['gpv_name']"
                    :items="filtered_gpv"
                    hide-no-data
                    filled
                    multiple
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-autocomplete
                    v-model="mainFilters.companyId"
                    :label="$t('company')"
                    :placeholder="$t('start_typing_to_search')"
                    item-text="label"
                    item-value="value"
                    :search-input.sync="search_company"
                    :loading="isSearching['company_name']"
                    :items="filtered_company"
                    hide-no-data
                    filled
                    multiple
                    clearable
                    required
                    :rules="requiredRulesArray"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-btn color="blue darken-1 mr-2" @click="onClickFilter">
              {{ $t("go") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <ve-table
              ref="tableRefRouteSummary"
              id="datatable_route_summary"
              fixed-header
              max-height="calc(100vh - 330px)"
              :columns="columns"
              :table-data="data"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :scroll-width="1500"
              :sort-option="sortOption"
              :cell-style-option="cellStyleOption"
            />
            <div v-show="showEmpty" class="empty-data">Data Empty.</div>
            <div class="table-pagination mt-2 text-right">
              <ve-pagination
                :total="pagination.totalRecords"
                :page-index="pagination.currentPage"
                :page-size="pagination.pageSize"
                :page-size-option="pageOptions"
                @on-page-number-change="pageNumberChange"
                @on-page-size-change="pageSizeChange"
              />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import download from "js-file-download";

export default {
  name: "RouteSummary",
  data: function() {
  return {
    valid_filter: true,
    requiredRules: [v => !!v || this.$t("required")],
    requiredRulesArray: [v => (v && v.length > 0) || this.$t("required")],
    select_startDate_menu: false,
    select_endDate_menu: false,
    mainFilters: {
      startDate: null,
      endDate: null,
      responsibleId: [],
      gpvId: [],
      companyId: []
    },
    tableFilters: {
      userId: [],
      responsibleId: [],
      companyId: []
    },
    isSearching: {
      responsible: false,
      gpv_name: false,
      company_name: false
    },
    search_responsible: null,
    filtered_responsible: [],
    search_gpv: null,
    filtered_gpv: [],
    search_company: null,
    filtered_company: [],
    data: [],
    pagination: {
      totalRecords: 0,
      totalPages: 1,
      currentPage: 1,
      pageSize: 10
    },
    pageOptions: [5, 10, 20, 50, 100],
    sorting: {},
    showEmpty: false,
    isLoadingData: false,
    loadingInstance: null,
    cellStyleOption: {
      bodyCellClass: ({ row, column, rowIndex }) => {
        return "";
      }
    },
    sortOption: {
      sortChange: params => {
        this.sortChange(params);
      }
    },
    filtered_table_user: [],
    filtered_table_responsible: [],
    filtered_table_company: [],

    isSearchingTable: {
      userName: false,
      responsibleName: false,
      companyName: false
    },

    search_table_user: null,
    search_table_responsible: null,
    search_table_company: null,
    current_pdf_worksessionId: null,
    tableFilterDebounceTimers: {}
  };
},

   computed: {
    columns () {
        const self = this

        return [
        {
            key: 'worksessionDate',
            title: this.$t('Date'),
            field: 'worksessionDate',
            align: 'left',
            width: 150,
            sortBy: ''
        },
        {
            key: "userFullName",
            title: "Usuario",
            field: "userFullName",
            align: "left",
            width: 150,
            fixed: "left",
            sortBy: "",
            filterCustom: {
                defaultVisible: false,
                onFilterContainerClick: (e) => e.stopPropagation(),
                render: ({ showFn, closeFn }, h) => {

                // Create a ref for the autocomplete
                let autocompleteRef = null;
                
                // Focus and open menu after render
                setTimeout(() => {
                    if (autocompleteRef) {
                    // Focus the input
                    if (autocompleteRef.$refs && autocompleteRef.$refs.input) {
                        autocompleteRef.$refs.input.focus();
                    }
                    // Activate the menu to show dropdown
                    if (autocompleteRef.isMenuActive !== undefined) {
                        autocompleteRef.isMenuActive = true;
                    }
                    // Alternative: trigger click to open
                    autocompleteRef.$el.click();
                    }
                }, 100);
                return (
                    <div 
                    class="custom-filter pa-3" 
                    style="min-width: 280px; display: flex; flex-direction: column; gap: 128px;"
                    on-mousedown={(e) => e.stopPropagation()}
                    on-click={(e) => e.stopPropagation()}
                    >
                    {/* Search Input */}
                    <div style="flex: 0 0 auto;">
                        <v-autocomplete
                        ref={(el) => { autocompleteRef = el }}
                        value={self.tableFilters.userId || []}
                        on-input={(v) => { self.tableFilters.userId = v || [] }}
                        items={self.filtered_table_user}
                        search-input={self.search_table_user}
                        on-update:search-input={(v) => { self.search_table_user = v }}
                        loading={self.isSearchingTable.userName}
                        item-text="label"
                        item-value="value"
                        label={self.$t("search")}
                        placeholder={self.$t("start_typing_to_search")}
                        hide-no-data
                        hide-details
                        clearable
                        filled
                        attach
                        autofocus
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        menu-props={{
                            closeOnClick: false,
                            closeOnContentClick: false,
                            maxHeight: "250px",
                            bottom: true
                        }}
                        on-mousedown={(e) => e.stopPropagation()}
                        on-click={(e) => e.stopPropagation()}
                        />
                    </div>
                    
                    {/* Dropdown items space - this will be populated by v-autocomplete's menu */}
                    <div style="flex: 1 1 auto; min-height: 0;"></div>
                    
                    {/* Buttons */}
                    <div class="d-flex justify-space-between" style="flex: 0 0 auto;">
                        <v-btn
                        small
                        text
                        color="grey darken-1"
                        on-click={() => {
                            self.tableFilters.userId = [];
                            self.search_table_user = null;
                            closeFn();
                            self.pagination.currentPage = 1;
                            self.getDataFromApi();
                        }}
                        >
                        {self.$t("cancel")}
                        </v-btn>
                        <v-btn
                        small
                        text
                        color="blue darken-2"
                        on-click={() => {
                            closeFn();
                            self.pagination.currentPage = 1;
                            self.getDataFromApi();
                        }}
                        >
                        {self.$t("search")}
                        </v-btn>
                    </div>
                    </div>
                );
                }
            }
        },
        {
            key: 'parentFullName',
            title: 'Responsable',
            field: 'parentFullName',
            align: 'left',
            width: 200,
            sortBy: '',
            filterCustom: {
                defaultVisible: false,
                onFilterContainerClick: e => e.stopPropagation(),
                render: ({ showFn, closeFn }, h) => {
                    // Create a ref for the autocomplete
                    let autocompleteRef = null;

                    // Focus and open menu after render
                    setTimeout(() => {
                        if (autocompleteRef) {
                            // Focus the internal input element
                            if (autocompleteRef.$refs && autocompleteRef.$refs.input) {
                                autocompleteRef.$refs.input.focus();
                            }
                            // Manually trigger the menu activation
                            if (autocompleteRef.isMenuActive !== undefined) {
                                autocompleteRef.isMenuActive = true;
                            }
                            // Trigger a click on the element to ensure the menu anchor attaches
                            autocompleteRef.$el.click();
                        }
                    }, 100);

                    // IMPORTANT: The return statement is required to render the JSX
                    return (
                        <div
                            class="custom-filter pa-3"
                            style="min-width: 280px; display: flex; flex-direction: column; gap: 128px;"
                            on-mousedown={e => e.stopPropagation()}
                            on-click={e => e.stopPropagation()}
                        >
                            <v-autocomplete
                                ref={(el) => { autocompleteRef = el }}
                                value={self.tableFilters.responsibleId || []}
                                on-input={v => { self.tableFilters.responsibleId = v || [] }}
                                items={self.filtered_table_responsible}
                                search-input={self.search_table_responsible}
                                on={{
                                    'update:search-input': v => { self.search_table_responsible = v }
                                }}
                                loading={self.isSearchingTable.responsibleName}
                                item-text="label"
                                item-value="value"
                                label={self.$t('search')}
                                placeholder={self.$t('start_typing_to_search')}
                                hide-no-data
                                hide-details
                                clearable
                                filled
                                multiple
                                chips
                                small-chips
                                deletable-chips
                                attach
                                menu-props={{
                                    closeOnClick: false,
                                    closeOnContentClick: false,
                                    maxHeight: "250px",
                                    bottom: true
                                }}
                                on-mousedown={e => e.stopPropagation()}
                                on-click={e => e.stopPropagation()}
                            />

                            <div class="d-flex justify-space-between" style="flex: 0 0 auto;">
                                <v-btn
                                    small 
                                    text 
                                    color="grey darken-1"
                                    on-click={() => {
                                        self.tableFilters.responsibleId = [];
                                        self.search_table_responsible = null;
                                        closeFn();
                                        self.pagination.currentPage = 1;
                                        self.getDataFromApi();
                                    }}
                                >
                                    {self.$t('cancel')}
                                </v-btn>
                                <v-btn
                                    small
                                    text
                                    color="blue darken-2"
                                    on-click={() => {
                                        closeFn();
                                        self.pagination.currentPage = 1;
                                        self.getDataFromApi();
                                    }}
                                >
                                    {self.$t('search')}
                                </v-btn>
                            </div>
                        </div>
                    );
                }
            }
        },
        {
    key: 'userCompanyName',
    title: 'Company',
    field: 'userCompanyName',
    align: 'left',
    width: 200,
    sortBy: '',
    filterCustom: {
        defaultVisible: false,
        onFilterContainerClick: (e) => e.stopPropagation(),
        render: ({ showFn, closeFn }, h) => {
            // Create a ref for the autocomplete
            let autocompleteRef = null;

            // Focus and open menu after render
            setTimeout(() => {
                if (autocompleteRef) {
                    // Focus the input
                    if (autocompleteRef.$refs && autocompleteRef.$refs.input) {
                        autocompleteRef.$refs.input.focus();
                    }
                    // Activate the menu to show dropdown
                    if (autocompleteRef.isMenuActive !== undefined) {
                        autocompleteRef.isMenuActive = true;
                    }
                    // Trigger click to ensure dropdown attaches
                    autocompleteRef.$el.click();
                }
            }, 100);

            return (
                <div 
                    class="custom-filter pa-3" 
                    style="min-width: 280px; display: flex; flex-direction: column; gap: 8px;"
                    on-mousedown={(e) => e.stopPropagation()}
                    on-click={(e) => e.stopPropagation()}
                >
                    <v-autocomplete
                        ref={(el) => { autocompleteRef = el }}
                        value={self.tableFilters.companyId || []}
                        on-input={(v) => { self.tableFilters.companyId = v || [] }}
                        items={self.filtered_table_company}
                        search-input={self.search_table_company}
                        on={{
                            'update:search-input': (v) => { self.search_table_company = v }
                        }}
                        loading={self.isSearchingTable.companyName}
                        item-text="label"
                        item-value="value"
                        label={self.$t('search')}
                        placeholder={self.$t('start_typing_to_search')}
                        hide-no-data
                        hide-details
                        clearable
                        filled
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        attach
                        menu-props={{
                            closeOnClick: false,
                            closeOnContentClick: false,
                            maxHeight: "250px",
                            bottom: true
                        }}
                        on-mousedown={(e) => e.stopPropagation()}
                        on-click={(e) => e.stopPropagation()}
                    />
                    
                    <div class="d-flex justify-space-between mt-3">
                        <v-btn
                            small
                            text
                            color="grey darken-1"
                            on-click={() => {
                                self.tableFilters.companyId = [];
                                self.search_table_company = null;
                                closeFn();
                                self.pagination.currentPage = 1;
                                self.getDataFromApi();
                            }}
                        >
                            {self.$t('cancel')}
                        </v-btn>
                        <v-btn
                            small
                            text
                            color="blue darken-2"
                            on-click={() => {
                                closeFn();
                                self.pagination.currentPage = 1;
                                self.getDataFromApi();
                            }}
                        >
                            {self.$t('search')}
                        </v-btn>
                    </div>
                </div>
            );
        }
    }
        },
        {
            key: 'pdf',
            title: 'PDF',
            align: 'center',
            width: 80,
            renderBodyCell: ({ row }, h) => {
                if (self.current_pdf_worksessionId === row.worksessionId) {
                    return (
                        <v-progress-circular
                            indeterminate
                            color="red darken-2"
                            size="20"
                            width="2"
                        ></v-progress-circular>
                    );
                }

                return (
                    <v-icon
                        color="red darken-2"
                        style="cursor: pointer;"
                        on-click={() => {
                            self.current_pdf_worksessionId = row.worksessionId;
                            self.downloadPdf(row.worksessionId);
                        }}
                    >
                        mdi-file-pdf-box
                    </v-icon>
                );
            }
        }
        ]
    }
    },

  
    watch: {
        search_responsible(val) {
            this.fetchMainFilterOptions("responsible", val);
        },
        search_gpv(val) {
            this.fetchMainFilterOptions("gpv_name", val);
        },
        search_company(val) {
            this.fetchMainFilterOptions("company_name", val);
        },
        // FIX: Properly handle search input as string with debounce
        search_table_user(val) {
            if (val !== null && val !== undefined && typeof val === 'string') {
            this.debouncedFetchTableFilter("userName", val);
            } else if (val === null || val === '' || val === undefined) {
            this.fetchTableFilterOptions("userName", "");
            }
        },
        search_table_responsible(val) {
            if (val !== null && val !== undefined && typeof val === 'string') {
            this.debouncedFetchTableFilter("responsibleName", val);
            } else if (val === null || val === '' || val === undefined) {
            this.fetchTableFilterOptions("responsibleName", "");
            }
        },
        search_table_company(val) {
            if (val !== null && val !== undefined && typeof val === 'string') {
            this.debouncedFetchTableFilter("companyName", val);
            } else if (val === null || val === '' || val === undefined) {
            this.fetchTableFilterOptions("companyName", "");
            }
        }
    },
  methods: {
    async fetchMainFilterOptions(columnName, searchValue = "") {
      if (this.isSearching[columnName]) return;
      this.isSearching[columnName] = true;
      try {
        const response = await ApiService.post("/salesforce/route-summary/route-summary-main-filters", {
          columnName,
          searchValue
        });
        if (columnName === "responsible") {
          this.filtered_responsible = response.data;
        } else if (columnName === "gpv_name") {
          this.filtered_gpv = response.data;
        } else if (columnName === "company_name") {
          this.filtered_company = response.data;
        }
      } catch (error) {
        logError(this.$t("error_fetching_options"));
      } finally {
        this.isSearching[columnName] = false;
      }
    },
    onChangeDates() {
      if (this.mainFilters.startDate > this.mainFilters.endDate) {
        this.mainFilters.endDate = this.mainFilters.startDate;
      }
    },
    async onClickFilter() {
      if (this.$refs.form_filter.validate()) {
        this.pagination.currentPage = 1;
        await this.getDataFromApi();
      }
    },
    pageNumberChange(pageIndex) {
      this.pagination.currentPage = pageIndex;
      this.getDataFromApi();
    },
    pageSizeChange(pageSize) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = pageSize;
      this.getDataFromApi();
    },
    sortChange(params) {
      this.sorting = params;
      this.getDataFromApi();
    },
    searchConfirm(closeFn) {
      closeFn();
      this.pagination.currentPage = 1;
      this.getDataFromApi();
    },
   searchCancel(closeFn, filterKey) {
    closeFn();
    this.tableFilters[filterKey] = [];  // ← Clear array
    this.getDataFromApi();
    },
    showLoading() {
      this.isLoadingData = true;
      if (!this.loadingInstance && this.$refs.tableRefRouteSummary) {
        this.loadingInstance = this.$veLoading({
          target: this.$refs.tableRefRouteSummary.$el,
          name: "flow"
        });
      }
      if (this.loadingInstance) {
        this.loadingInstance.show();
      }
    },
    hideLoading() {
      this.isLoadingData = false;
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
    },
    async getDataFromApi() {
      this.showLoading();
      try {
        const response = await ApiService.post("/salesforce/route-summary", {
          mainFilters: this.mainFilters,
          tableFilters: this.tableFilters,
          sorting: this.sorting,
          pagination: {
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        });
        this.data = response.data.data;
        this.pagination = response.data.pagination;
        this.showEmpty = this.data.length === 0;

        await this.loadTableFilterOptions();
      } catch (error) {
        logError(this.$t("error_fetching_data"));
      } finally {
        this.hideLoading();
      }
    },
    async fetchTableFilterOptions(columnName, searchValue = "") {
        if (this.isSearchingTable[columnName]) return;
        this.isSearchingTable[columnName] = true;


        try {
            const response = await ApiService.post("/salesforce/route-summary/route-summary-table-filters", {
            columnName,
            searchValue: typeof searchValue === 'string' ? searchValue : "", // Ensure string
            mainFilters: this.mainFilters,
            tableFilters: this.tableFilters
            });


            if (columnName === "userName") {
            this.filtered_table_user = response.data;
            } else if (columnName === "responsibleName") {
            this.filtered_table_responsible = response.data;
            } else if (columnName === "companyName") {
            this.filtered_table_company = response.data;
            }
        } catch (error) {
            console.error(`Error fetching table filter options for ${columnName}:`, error);
            logError("Error fetching table filter options");
        } finally {
            this.isSearchingTable[columnName] = false;
        }
    },

    debouncedFetchTableFilter(columnName, searchValue) {
        if (this.tableFilterDebounceTimers && this.tableFilterDebounceTimers[columnName]) {
            clearTimeout(this.tableFilterDebounceTimers[columnName]);
        }

        if (!this.tableFilterDebounceTimers) {
            this.tableFilterDebounceTimers = {};
        }

        this.tableFilterDebounceTimers[columnName] = setTimeout(() => {
            this.fetchTableFilterOptions(columnName, searchValue);
        }, 500);
    },

   async loadTableFilterOptions() {
        // Load initial options for all filters
        await Promise.all([
            this.fetchTableFilterOptions("userName", ""),
            this.fetchTableFilterOptions("responsibleName", ""),
            this.fetchTableFilterOptions("companyName", "")
        ]);
    },
    async downloadPdf(worksessionId) {
        try {
        const response = await ApiService.get(
            `/worksession/downloadpdfdailysummary/${worksessionId}`,
            { responseType: "blob" } // Important for file download
        );

        download(response, `daily-summary-${worksessionId}.pdf`);

        logInfo("PDF downloaded successfully");
        } catch (error) {
        logError("Error downloading PDF");
        console.error(error);
        }finally{
           this.current_pdf_worksessionId = null;
        }
    },
    async init() {
      await this.fetchMainFilterOptions("responsible");
      await this.fetchMainFilterOptions("gpv_name");
      await this.fetchMainFilterOptions("company_name");
    }
  },
  mounted() {
    this.init();
  },

  beforeDestroy() {
    // Clear all debounce timers
    if (this.tableFilterDebounceTimers) {
        Object.values(this.tableFilterDebounceTimers).forEach(timer => {
        if (timer) clearTimeout(timer);
        });
    }
  }
};
</script>

<style>
  
.ve-dropdown-popper .ve-dropdown-dd .ve-dropdown-items{
    min-height: 50px;
    position: relative;
    text-overflow: ellipsis;
    word-wrap: normal;
    white-space: nowrap;
    top: 2px;
    left: 0px;
    list-style: none;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    border: 1px solid #d1dbe5;
    padding: 5px 0px;
    overflow: initial;
}

</style>
